import * as React from 'react';
import { Dropdown } from 'antd';
import cls from 'classnames';

import { LocaleValue, getCurrentLocale, changeLanguage } from '../../i18n';
import { IsMobileCtx } from '../../context/isMobile';

import { ReactComponent as Icon } from '@svg/questionnaire_language_icon.svg';
import { ReactComponent as DoneIcon } from '@svg/questionnaire_done.svg';
import { ReactComponent as DropdownIcon } from '@svg/questionnaire_arrow_down.svg';
import './index.less';

const textMap = {
    [LocaleValue.en]: 'English',
    [LocaleValue.zh]: '中文 (简体)'
};

const langList = [
    {
        type: LocaleValue.en,
        text: 'English'
    },
    { type: LocaleValue.zh, text: '中文 (简体)' }
];

const { useState, useContext } = React;
const LanguageChange: React.FC = () => {
    const [vis, setVis] = useState(false);
    const { isMobile } = useContext(IsMobileCtx);
    const currentLang = getCurrentLocale();

    const handleItemClick = (type: LocaleValue) => {
        changeLanguage(type);
    };

    const handleDropdownClick = () => {
        setVis(!vis);
    };

    const menu = (
        <div
            className={cls({
                'language-change-dropdownContent--mobile': isMobile,
                'language-change-dropdownContent': !isMobile
            })}
        >
            {langList.map((item) => (
                <div
                    key={item.type}
                    className={cls({
                        'language-change-dropdownContent__item--active': item.type === currentLang
                    })}
                    onClick={() => {
                        handleItemClick(item.type);
                    }}
                >
                    <div>{item.text}</div>
                    <DoneIcon />
                </div>
            ))}
        </div>
    );

    return (
        <Dropdown
            overlay={menu}
            visible={vis}
            getPopupContainer={(triggerNode) => triggerNode.parentElement as HTMLElement}
        >
            <div
                className={cls({
                    'dropdown--show': vis,
                    'language-change-wrapper--mobile': isMobile,
                    'language-change-wrapper': !isMobile
                })}
                onClick={handleDropdownClick}
            >
                <Icon />
                <span>{textMap[currentLang]}</span>
                <DropdownIcon />
            </div>
        </Dropdown>
    );
};

export default LanguageChange;
